import { render, staticRenderFns } from "./BcWizard.vue?vue&type=template&id=2369b79c&scoped=true"
import script from "./BcWizard.vue?vue&type=script&lang=js"
export * from "./BcWizard.vue?vue&type=script&lang=js"
import style0 from "./BcWizard.vue?vue&type=style&index=0&id=2369b79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369b79c",
  null
  
)

export default component.exports